import API from './../api';

export default {
    namespaced: true,

    state() {
        return {
            user: {},
            mainMenuItems: [],
            mainMenuDropdowns: [],
            rightMenuItems: [],
            rightMenuDropdowns: [],
            helpMenu: [],
            workOrders: {},
            failedTransactions: {},
            notifications: [],
            messages: [],
            clonePropertyOptions: [],
            is_impersonated: false,
            loading: false,
            deviceList: [],
            currentToken: null,
            fcm_client_config: {},
            fcm_vapidkey: null,
            notification_list: [],
            isNotificationSupported: true,
        };
    },

    getters: {
        userID: state => state.user.id,
        userSubscriberId: state => state.user.subscriber_id,
        userSubscriberName: state => state.user.subscriber_name,
        userFullName: state =>
            Object.keys(state.user).length !== 0
                ? `${state.user.first_name} ${state.user.last_name}`
                : '',
        userEmail: state => state.user.email || '',
        userUnicodeDateFormat: state => state.user.unicode_date_format || 'P',
        userUnicodeChargesTableDateFormat: state => state.user.unicode_charges_table_date_format || 'P',
        userTimeFormat: state => state.user.time_format || 'hh:mm a',
        userToday: state => state.user.user_today,
        userCurrencySymbol: state => state.user.currency_symbol || '',
        userCompany: state => state.user.company,
        userEmailSignature : state => state.user.email_signature,
        userDoNotDegradeInvoiceStatus : state => state.user.do_not_degrade_invoice_status,
        userIsSubscriber: state => state.user.is_subscriber,
        userIsTeamMember: state => state.user.is_team_member,
        userIsOwner: state => state.user.is_owner,
        userIsAdmin: state => state.user.is_admin,
        userPermissions: state => state.user.permissions,
        userHasPayPal: state => state.user.has_paypal,
        userHasCCGateway: state => state.user.has_cc_gateway,
        userHasStripeGateway: state => state.user.has_stripe_gateway,
        userHasPreauth: state => state.user.has_preauth,
        userPayPalWebsite: state => state.user.paypal_website,
        userVirtualTerminalUrl: state => state.user.virtual_terminal_url,
        userHasActiveDevices: state => state.user.has_active_devices,
        userWebsocketToken: state => state.user.websocket_token,
        userAllowWordpress: state => state.user.allow_wordpress,
        userIsTrial: state => state.user.is_trial,
        userHasCustomSMSGateway: state => state.user.has_custom_sms_gateway,
        userIsUnlayerTester: state => state.user.is_unlayer_test_user,
        userCanUseUnlayer: state => state.user.can_use_unlayer,
        mainMenuItems: state => state.mainMenuItems,
        mainMenuDropdowns: state => state.mainMenuDropdowns,
        rightMenuItems: state => state.rightMenuItems,
        rightMenuDropdowns: state => state.rightMenuDropdowns,
        helpMenu: state => state.helpMenu,
        helpMenuLength: state => state.helpMenu.length,
        workOrdersCount: state => state.workOrders.n_work_orders || 0,
        workOrdersHref: state => state.workOrders.href || '',
        failedTransactionsShowModalNotification: state => state.failedTransactions.show_modal_notification || false,
        failedTransactionsCount: state => state.failedTransactions.n_failed_transactions || 0,
        undergoingResolutionTransactionsCount: state => state.failedTransactions.n_undergoing_resolution_transactions || 0,
        failedTransactionsHref: state => state.failedTransactions.href || '',
        notifications: state => state.notifications,
        notificationsCount: state => state.notifications.length,
        messages: state => state.messages,
        messagesCount: state => state.messages.length,
        messagesTotal: state =>
            state.notifications.length + state.messages.length,
        clonePropertyOptions: state => state.clonePropertyOptions,
        isLoading: state => state.loading,
        isImpersonated: state => state.is_impersonated,
        deviceList: (state) => state.deviceList,
        currentToken: (state) => state.currentToken,
        fcmClientConfig: (state) => state.fcm_client_config,
        fcmVapidKey: (state) => state.fcm_vapidkey,
        notificationList: (state) => state.notification_list,
        isNotificationSupported: (state) => state.isNotificationSupported,
    },

    mutations: {
        gotAccount(state, response) {
            if (response.data) {
                if (response.data.user) {
                    state.user = response.data.user;
                }
                if (response.data.main_menu_items) {
                    state.mainMenuItems = response.data.main_menu_items;
                }
                if (response.data.main_menu_dropdowns) {
                    state.mainMenuDropdowns = response.data.main_menu_dropdowns;
                }
                if (response.data.right_menu_items) {
                    state.rightMenuItems = response.data.right_menu_items;
                }
                if (response.data.right_menu_dropdowns) {
                    state.rightMenuDropdowns =
                        response.data.right_menu_dropdowns;
                }
                if (response.data.help_menu) {
                    state.helpMenu = response.data.help_menu;
                }
                if (response.data.work_orders) {
                    state.workOrders = response.data.work_orders;
                }
                if (response.data.is_impersonated) {
                    state.is_impersonated = response.data.is_impersonated
                }
                if (response.data.fcm_client_config) {
                    state.fcm_client_config = response.data.fcm_client_config
                }
                if (response.data.fcm_vapidkey) {
                    state.fcm_vapidkey = response.data.fcm_vapidkey
                }
            }
        },
        gotClonePropertyOptions(state, response) {
            state.clonePropertyOptions = response.data || [];
        },
        gotFailedTransactions(state, response) {
            state.failedTransactions = response.data || {};
        },
        gotNotifications(state, response) {
            state.notifications = response.data || [];
        },
        gotMessages(state, response) {
            state.messages = response.data || [];
        },
        dismissedNotification(state, notificationId) {
            state.notifications = state.notifications.filter(
                item => item.id !== notificationId
            );
        },
        dismissedMessage(state, message) {
            state.messages = state.messages.filter(
                item => item.id !== message.id
            );
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setDevices(state, devices) {
            state.deviceList = devices;
        },
        setToken(state, token) {
            state.currentToken = token;
        },
        setNotificationList(state, notification_list) {
            state.notification_list = notification_list;
        },
        setIsNotificationSupported(state, isNotificationSupported) {
            state.isNotificationSupported = isNotificationSupported;
        },
    },

    actions: {
        async fetchAccount({ dispatch, commit }) {
            commit('setLoading', true)
            commit('gotAccount', await API.get('/app/header/account/'));
            commit('setLoading', false)
        },
        async fetchClonePropertyOptions({ commit }) {
            commit(
                'gotClonePropertyOptions',
                await API.get('/app/header/clone/')
            );
        },
        async fetchFailedTransactions({ dispatch, commit }) {
            commit('gotFailedTransactions', await API.get('/app/header/failed-transactions/'));
        },
        async fetchNotifications({ dispatch, commit }) {
            commit(
                'gotNotifications',
                await API.get('/app/header/notification/')
            );
            await dispatch('fetchMessages');
        },
        async fetchMessages({ commit }) {
            commit('gotMessages', await API.get('/app/header/message/'));
        },
        async dismissNotification({ commit }, notification) {
            commit('dismissedNotification', notification.id);
            try {
                await API.delete(
                    `/app/header/notification/${notification.id}/`
                );
            } catch (err) {
                console.log(err);
            }
        },
        async dismissMessage({ commit }, message) {
            commit('dismissedMessage', message);
            try {
                await API.delete(`/app/header/message/${message.id}/`);
            } catch (err) {
                console.log(err);
            }
        },
    },
};
